import { SET_VEHICLES_CATEGORY_LIST, SET_VEHICLES_CATEGORY_INFO } from './constant';

const DEFAULT_STATE = {
  list: null,
  info: null
};

const categoryReducer = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case SET_VEHICLES_CATEGORY_LIST:
      return { ...state, list: action.payload };
    case SET_VEHICLES_CATEGORY_INFO:
      return { ...state, info: action.payload };
    default:
      return state;
  }
};

export default categoryReducer;
